import { FaLinkedinIn, FaInstagram, FaFacebookF, FaSnapchatGhost, FaTiktok } from "react-icons/fa";

export const COMPANY_LINKEDIN = {
  key: "linkedin",
  name: "LinkedIn",
  href: "https://www.linkedin.com/company/instaspark-app/",
  Icon: FaLinkedinIn,
  chip: "bg-[#0A66C2] text-white",
};

export const CALLUM_SOCIALS = [
  { key: "tiktok", name: "TikTok", href: "https://www.tiktok.com/@thecallumlamb?_r=1&_t=ZN-9AaCNiQZTK2", Icon: FaTiktok, chip: "bg-black text-white ring-1 ring-white/30 [filter:drop-shadow(1.5px_0_0_#FE2C55)_drop-shadow(-1.5px_0_0_#25F4EE)]" },
  { key: "instagram", name: "Instagram", href: "https://www.instagram.com/callumlambofficial?obrf=MWFldjFwdWFycDE3ZQ==", Icon: FaInstagram, chip: "bg-gradient-to-tr from-[#FEDA75] via-[#D62976] to-[#4F5BD5] text-white" },
  { key: "linkedin", name: "LinkedIn", href: "https://www.linkedin.com/in/callum-lamb-05463a320?utm_source=share_via&utm_content=profile&utm_medium=member_android", Icon: FaLinkedinIn, chip: "bg-[#0A66C2] text-white" },
  { key: "facebook", name: "Facebook", href: "https://www.facebook.com/share/1Bo61xE5zV/", Icon: FaFacebookF, chip: "bg-[#1877F2] text-white" },
  { key: "snapchat", name: "Snapchat", href: "https://www.snapchat.com/add/callumlamb05?share_id=08eITvGnOkc&locale=en-GB", Icon: FaSnapchatGhost, chip: "bg-[#FFFC00] text-black" },
];
